import { colors } from 'styles/colors';
import { muiStyles } from 'utils/design';

export const useStyles = muiStyles({
  grid: {
    flexGrow: 1,
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    alignItems: 'flex-start',
  },
  headerRow: {
    background: `${colors.neutralVeryLight} !important`,
    fontWeight: 'bolder',
    '&.ag-row-hover': {
      background: colors.neutralLight,
    },
  },
});
